export function isMobile(value) {
  return /^1[3-9]\d{9}$/.test(value)
}
